import DCSL from "../src/img/DCSL.jpg";
import Klotho from "../src/img/klotho.jpg";
import lifestyleMarketing from "../src/img/lifestyleMarketing.jpg";
import bigumaku from "../src/img/bigumaku.jpg";
import kuatoStudios from "../src/img/kuatoStudios.jpg";
import fragGames from "../src/img/fragGames.jpg";
export const products = [
  {
    id: 1,
    img: DCSL,
    link: "https://www.dcsl.com/",
  },
  {
    id: 2,
    img: Klotho,
    link: "https://klo.dev/",
  },
  {
    id: 3,
    img: lifestyleMarketing,
    link: "https://www.lifestylemarketing.com/",
  },
  {
    id: 4,
    img: bigumaku,
    link: "https://www.youtube.com/@bigumaku201",
  },
  {
    id: 5,
    img: kuatoStudios,
    link: "https://www.youtube.com/user/KuatoStudios",
  },
  {
    id: 6,
    img: fragGames,
    link: "https://www.frag-games.com/",
  },
];
